import { getOrCreateSocket } from "socket/socket";
import { store } from "store/store";

export const renameAnimal = (animalIndex: number, name: string) => {
  const socket = getOrCreateSocket();
  if (store.currentRoom && store.currentPlayer?.cards[animalIndex]) {
    socket.emit("renameAnimal", store.currentRoom, animalIndex, name);
  }
};
